module.exports = __webpack_public_path__ + "static/logo-53c49f43d81269821df91396b61bd2c3.svg";